import React from 'react';

interface VersionDisplayProps {
  className?: string;
}

const VersionDisplay: React.FC<VersionDisplayProps> = ({ className = '' }) => {
  const version = 'V.1.0.199';

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white/90 backdrop-blur-sm rounded-lg px-3 py-2 shadow-lg border border-gray-200">
        <span className="text-xs font-mono text-gray-600">{version}</span>
      </div>
    </div>
  );
};

export default VersionDisplay;